// material-ui
import { useTheme } from '@mui/material/styles';

import logo from 'assets/images/logo.jpg';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();

    return <img src={logo} alt="Rancher" height="70" style={{ borderRadius: '50%' }} />;
};

export default Logo;
